import cx from "clsx";
import { HighlightGalleryCollector } from "kreate-common/modules/business-types";
import Flex from "kreate-common/modules/kreate-ui/components/Flex";

import CardGallery from "./components/CardGallery";
import styles from "./index.module.scss";

import { EM_DASH } from "@/modules/common-utils/unicode";

type Props = {
  className?: string;
  style?: React.CSSProperties;
  topGalleries: HighlightGalleryCollector[] | undefined | null;
};

export default function SectionTopGalleries({
  className,
  style,
  topGalleries,
}: Props) {
  return (
    <div className={cx(styles.container, className)} style={style}>
      <Flex.Row
        justifyContent="space-between"
        alignItems="center"
        style={{ marginBottom: "32px" }}
      >
        <h2 className={styles.title}>{`Top ${
          topGalleries?.length || EM_DASH
        } Art Galleries`}</h2>
        {/* <Link className={styles.linkViewMore} href="#">
          {"View More"}
        </Link> */}
      </Flex.Row>
      <div className={styles.grid}>
        {topGalleries?.map((galleryCollector, index) => (
          <CardGallery galleryCollector={galleryCollector} key={index} />
        ))}
      </div>
    </div>
  );
}
